import {MovieLayerEffectType, MovieMaskType} from './movie.enums';

import {CLSelectorOption} from 'common/src/components/Selectors/CLSelector/CLSelector.types';

const movieBRPattern = /\r\n|\n|\r|\u0003|\$€\$/g;
const valueEpsilon = 1e-6;

const animationFunctions = {
  linear: {
    i: {x: [0.25], y: [0.25]},
    o: {x: [0.75], y: [0.75]},
  },
  ease: {
    i: {x: [0.42], y: [0]},
    o: {x: [0.58], y: [1]},
  },
  easeIn: {
    i: {x: [0.42], y: [0]},
    o: {x: [1], y: [1]},
  },
  easeOut: {
    i: {x: [0], y: [0]},
    o: {x: [0.58], y: [1]},
  },
  easeInOut: {
    i: {x: [0.42], y: [0]},
    o: {x: [0.58], y: [1]},
  },
};

const effectUiName: Record<MovieLayerEffectType, string> = {
  [MovieLayerEffectType.Fill]: 'Fill Color',
  [MovieLayerEffectType.ColorOverlay]: 'Color Overlay',
  [MovieLayerEffectType.BoxBlur]: 'Blur',
  [MovieLayerEffectType.Shadow]: 'Drop Shadow',
  [MovieLayerEffectType.Mask]: 'Mask',
  [MovieLayerEffectType.TrkMatte]: 'TrackMatte',
};

const maskTypeUiName: Record<MovieMaskType, string> = {
  [MovieMaskType.Add]: 'Add',
  [MovieMaskType.Subtruct]: 'Subtruct',
  [MovieMaskType.Intersect]: 'Intersect',
};

const fpsOptions: CLSelectorOption<number>[] = [
  {label: '23.976', value: 23.976},
  {label: '24', value: 24},
  {label: '25', value: 25},
  {label: '29.97', value: 29.97},
  {label: '30', value: 30},
];

export {movieBRPattern, effectUiName, maskTypeUiName, fpsOptions, valueEpsilon, animationFunctions};
